import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import RichTextDisplay from '../RichTextDisplay';

const styles = () => ({
  root: {},
});

function RichTextDisplayOverride({
  value,
  className,
  ...rest
}) {
  return (
    <RichTextDisplay content={value} {...rest} />
  );
}

RichTextDisplayOverride.defaultProps = {
  value: null,
};

RichTextDisplayOverride.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.node,
};

export default withStyles(styles, { name: 'RichTextDisplay' })(
  RichTextDisplayOverride,
);
